import {createUseStyles} from "react-jss";
import {colors} from "constants/colors";

const styles = createUseStyles({
  gridMobileWrapperClassName: {
    marginBottom: 0,
    padding: 0
  },
  gridWrapperClassName: {
    "& .rdt_TableCol_Sortable": {
      overflow: "visible"
    },
    borderRadius: 'unset',
    border:"none",
    "& .rdt_TableCell:last-child": {
      paddingRight: "24px"
    },
  },
  redemptionHistory: {
  },
  redemptionHistoryHeader: {
    display: 'flex',
    flexDirection: 'row'
  },
  redemptionHistoryHeaderTitleContainer: {
    width: '100%'
  },
  redemptionHistoryHeaderButtonContainer: {
    margin: 'auto'
  },
  downloadLoadingState: {
    backgroundColor: `${colors.brightBlue} !important`,
    pointerEvents: "none",
    border: `1px solid ${colors.brightBlue}`
  },
  spinnerStyle: {
    '& span': {
      borderColor: `${colors.darkerGrey} ${colors.darkerGrey} transparent !important`
    }
  },
  redemptionHistoryCard: {
    marginBottom: "48px",
    borderColor: colors.lightGrey,
    '& .card-title': {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '28px',
      color: colors.lightBlack
    },
    '& .card-text': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      color: colors.mediumGrey
    },
    '& .card-header': {
      borderColor: colors.lightGrey,
      backgroundColor: 'transparent'
    },

    '& .card-header, & .card-footer': {
      borderColor: colors.lightGrey,
      padding: '20px 24px',
    },
  },
  redemptionHistoryCardHeaderSmall: {
    '&.card-header': {
      padding: '12px 16px',
    },
  },
  redemptionHistoryCardBody: {
    padding: "unset",
    '& *': {
      fontSize: 12,
      fontWeight: 400,
    },
  },
  text: {
    fontSize: 16,
    lineHeight: "24px",
    color: colors.inactiveGrey,
  },
  bold: {
    fontWeight: 500,
    fontSize: 14,
    color: colors.grey,
    lineHeight: "20px"
  },
  loyaltyPointsText: {
    margin: 0,
    fontSize: 16,
  },
  downloadBtn: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    padding: "8px 14px",
    width: "fit-content",
    "& svg": {
      marginRight: "8px",
    },
  },
  downloadDisableBtn: {
    extend: "downloadBtn",
    borderColor: colors.lightGrey,
  },
  downloadActiveIcon: {
    "& svg": {
      "& path": {
        stroke: colors.mediumGrey,
      },
    },
  },
  downloadDisableIcon: {
    "& svg": {
      "& path": {
        stroke: colors.darkGrey,
      },
    },
  },
});

export default styles;
